import axios from "axios";

import { FETCH_FEATURE_ACCESS } from "./type";

// Features opened to some schools only (server utils/featureAccess.js).
// Every request is `silentError`: the access check is a background request
// the navbars send on every site open, and the settings page shows its own
// errors.
const SILENT = { silentError: true };

// What the signed-in user may use: { classRecords, classHealthCheck,
// quizResults }. One request at a time: both navbars ask on mount.
let accessRequest = null;
export const fetchFeatureAccess = () => (dispatch) => {
  if (!accessRequest) {
    accessRequest = axios
      .get("feature-access", SILENT)
      .then((response) => {
        const { access, unknown } = response.data;
        if (!access) throw new Error("Feature access is not available");
        // `unknown`: features the server could not decide (it could not load
        // the user's schools), false meanwhile. What is known is shown; the
        // rest is a failure to the caller, which asks again later.
        const incomplete = Array.isArray(unknown) && unknown.length > 0;
        dispatch({
          type: FETCH_FEATURE_ACCESS,
          payload: { access, incomplete }
        });
        if (incomplete) throw new Error("Feature access is incomplete");
        return access;
      })
      .finally(() => {
        accessRequest = null;
      });
  }
  return accessRequest;
};

// Admin: { [featureKey]: { mode: off | list | all, schools, teachers } }
export const fetchFeatureAccessSettings = () => async () => {
  const response = await axios.get("feature-access/settings", SILENT);
  return response.data.settings;
};

// Saves the features sent, answers every feature's settings
export const saveFeatureAccessSettings = (settings) => async () => {
  const response = await axios.put("feature-access/settings", settings, SILENT);
  return response.data.settings;
};
